import React from 'react';

import AddOrEditInsurance from '../../../Insurance/AddOrEditInsurance';

export default function Insurance({
  loanId,
  isVisible,
  refetchLoan,
  readOnly,
}) {
  return (
    <AddOrEditInsurance
      loanId={loanId}
      isVisible={isVisible}
      refetchLoan={refetchLoan}
      readOnly={readOnly}
    />
  );
}
